module.exports = __webpack_public_path__ + "img/element-link.08eec4e.svg";